<template>
    <div>
        <section class="page-banner page-banner-sec">
            <h1 class="section-title" style="">{{ $t('videos.header')}}</h1>
        </section>
        <div id="layout-content" class="pt-4">
        	<div class="container">
                <ClipLoader :loading="!loaded" color="#5FB0E2" size="150px" class="p-5"></ClipLoader>

                    <!-- just with cards auto arrange, but its not center -->
                    <!-- <div v-for="id in sortedOrder" :key="id" v-if="loaded">
                        <div v-if="locale == showGlobalVideos[id].language">
                            <div class="card m-2" style="width: 25rem;">
                                <div v-b-tooltip :title="(showGlobalVideos[id].title && showGlobalVideos[id].title.length > 35) ? 'View title' : ''" @click="fullText(showGlobalVideos[id].title, 'Title')" class="card-header">{{shortText(showGlobalVideos[id].title)}}</div>
                                <div class="card-body">
                                    <video controls class="card-img-top">
                                        <source :src="showGlobalVideos[id].url" type="video/mp4">
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                                <div v-b-tooltip :title="(showGlobalVideos[id].description && showGlobalVideos[id].description.length > 35) ? 'View Description' : ''" @click="fullText(showGlobalVideos[id].description, 'Description')" class="card-footer">{{shortText(showGlobalVideos[id].description)}}</div>
                            </div>
                        </div>

                    </div> -->

                <div class="row" v-for="ida in sortedOrder" :key="ida[0]" v-if="loaded && numberOfCards==2">
                    <!-- <div class="col-sm-2"></div> -->
                    <div class="col-sm-6" v-for="id in ida" :key="id">
                        <div>
                            <div class="card m-2">
                                <div v-b-tooltip :title="(showGlobalVideos[id].title && showGlobalVideos[id].title.length > 35) ? 'View title' : ''" @click="fullText(showGlobalVideos[id].title, 'Title')" class="card-header">{{shortText(showGlobalVideos[id].title)}}</div>
                                <div class="card-body">
                                    <!-- works all browser and draggable -->
                                    <!-- <video controls playsinline class="card-img-top">
                                        <source
                                        src='https://s3.ca-central-1.amazonaws.com/rcmpstudy-video/video/Commr+Longitudinal+Study-Cellular+High.mp4' 
                                        type="video/mp4">
                                        Your browser does not support the video tag.
                                    </video> -->

                                    <!-- does not works on safari and not draggable on safari -->
                                    <!-- <video controls playsinline class="card-img-top">
                                        <source
                                        src='https://video.pspnet.ca/2025/01/caeleigh_video_rev3.mp4' 
                                        type="video/mp4">
                                        Your browser does not support the video tag.
                                    </video> -->

                                    <!-- does not works on safari and not draggable on safari/chrome-->
                                    <video controls playsinline preload="metadata" class="card-img-top">
                                        <source
                                        :src='showGlobalVideos[id].url + "?id=" +id'
                                        type="video/mp4">
                                        Your browser does not support the video tag.
                                    </video>

                                </div>
                                <!-- <div v-b-tooltip :title="(showGlobalVideos[id].description && showGlobalVideos[id].description.length > 35) ? 'View Description' : ''" @click="fullText(showGlobalVideos[id].description, 'Description')" class="card-footer">{{shortText(showGlobalVideos[id].description)}} 
                                    <span v-if="(showGlobalVideos[id].description && showGlobalVideos[id].description.length > 35)" style="float: right;">Show More</span>
                                </div> -->
                                <div class="card-footer">{{shortText(showGlobalVideos[id].description)}} 
                                    <span v-if="(showGlobalVideos[id].description && showGlobalVideos[id].description.length > 35)" class="text-primary" style="float: right;" @click="fullText(showGlobalVideos[id].description, 'Description')">
                                        See More
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-sm-2"></div> -->
                </div>


                <!-- <div  v-for="id in sortedOrder" :key="id" v-if="loaded && numberOfCards==1">
                    <div class="card m-2">
                        <div v-b-tooltip :title="Title" class="card-header">{{showGlobalVideos[id].title}}</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm">
                                    <video controls class="card-img-top">
                                        <source :src="showGlobalVideos[id].url" type="video/mp4">
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                                <div class="col-sm">
                                    <div @click="fullText(showGlobalVideos[id].description, 'Description')">{{shortText(showGlobalVideos[id].description, 300)}}</div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div> -->

            </div>
        </div>


    </div>
</template>

<script>

// Vuex Stores
import { mapActions, mapGetters } from 'vuex'

// Common OTU Components
import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { errHandler } from '@/lib/handlers'
import moment from 'moment';

export default {
    name: 'Videos',
    components: {
		ClipLoader: () => import('vue-spinner/src/ClipLoader')
	},
    data () {
        return {
            loaded: false,
            numberOfCards: 2
        }
    },
    created () {
        this.getVideos({vtype: "global", clientId: this.clientId}).then((res) => {
            this.loaded = true;
        });
     },
    computed: {
        showGlobalVideos () {
            let videos = this.$store.state.videos.gloablVideos;
            return videos;
        },
        sortedOrder() {
            let sortedKeys = [];
            let sortedKeys_final = [];
            
            if (this.showGlobalVideos){
                if (this.numberOfCards == 1) {
                    sortedKeys = Object.entries(this.showGlobalVideos).filter( (a) => { return a[1].language == this.locale; }).sort( (a,b) => { return a[1].position - b[1].position; }).map(a => a[0]);
                    return sortedKeys;
                }
                if (this.numberOfCards == 2) {
                    sortedKeys = Object.entries(this.showGlobalVideos).filter( (a) => { return a[1].language == this.locale; }).sort( (a,b) => { return a[1].position - b[1].position; }).map(a => a[0]);
                }
            }
            if (this.numberOfCards == 2) {
                if (sortedKeys.length > 0){
                    const chunkSize = 2;
                    for (let i = 0; i < sortedKeys.length; i += chunkSize) {
                        const chunk = sortedKeys.slice(i, i + chunkSize);
                        sortedKeys_final.push(chunk);
                    }
                }
                return sortedKeys_final;
            }
        },
        enrollment () {
			return this.$store.state.programs.enrollment;
		},
        enrollmentId () {
            return this.enrollment.id;
        },
        clientId () {
            return this.$store.state.auth.user.id;
        },
        locale () {
			return this.$i18n.locale;
		}
    },
    methods: {
        ...mapActions(['getVideos']),
		...mapNotificationEventActions,

        fullText (text, label) {
            if(text && text.length > 35) {
                this.$swal({
                    title: label,
                    text: text,
                    confirmButtonText: 'OK',
                    width: '800px'
			    });
            }
		},
        shortText (text, count=35) {
            let result = '';
            if (text && text.length > count) {
                result = text.substr(0,count) + " ..."
            }
            if (text && text.length <= count) {
                result = text
            }
            return result;
        }
    }
}


</script>